function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Path>",
  fill: "#e60000",
  cx: 155.91,
  cy: 155.91,
  r: 155.91
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Path>",
  fill: "#fff",
  d: "M157.13 242.31c-42.57.14-86.87-36.19-87.06-94.54C69.95 109.18 90.76 72 117.37 50c26-21.49 61.51-35.28 93.76-35.39 4.15 0 8.49.33 11.15 1.23-28.2 5.85-50.64 32.09-50.54 61.86a16.16 16.16 0 00.19 2.52c47.18 11.49 68.6 40 68.73 79.35s-30.97 82.56-83.53 82.74z"
}));

var SvgVodafoneLogo = function SvgVodafoneLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 311.81 311.81",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgVodafoneLogo;